import { BUSINESS_VERTICAL, EVENT_CATEGORY } from '../../constants/EventHelper'
import { getCommonParams } from '../CommonParams'
import { EVENT_PARAM_KEY as EPK } from '../../constants/EventParamKey'
import {
  BannerClickedEventParams,
  BannerContentInterface,
} from '../../events/banner/BannerClickedEvent'

export const CONTENT_TYPE = {
  STATIC: 'static',
  GIF: 'gif',
  VIDEO: 'video',
}

const BANNER_TYPE = {
  CAROUSEL: 'carousel',
  FIXED: 'fixed',
}

interface BannerInput {
  source?: string | null
  campaignName?: string | null
  adId?: string | null
  name?: string | null
  imageUrl?: string | null
  position?: number | null
  bannerType?: string | null
  type?: string
  link?: string | null
  duration?: number | null
  redeemedStatus?: boolean | null
  dwellTime?: string | number | null
}
const createBannerEventParams = (
  banner: BannerInput | null | undefined,
  businessVertical: string = BUSINESS_VERTICAL.GROCERY,
  includeDwellTime: boolean = false,
): BannerClickedEventParams => {
  const {
    source = null,
    campaignName = null,
    adId = null,
    name = null,
    imageUrl = null,
    position = null,
    bannerType = null,
    type = CONTENT_TYPE.STATIC,
    link = null,
    duration = 0,
    redeemedStatus = null,
    dwellTime = null,
  } = banner || {}

  const isOsmos = source?.toLowerCase() === 'osmos'
  const contentType = [
    CONTENT_TYPE.STATIC,
    CONTENT_TYPE.GIF,
    CONTENT_TYPE.VIDEO,
  ].includes(type)
    ? type
    : CONTENT_TYPE.STATIC

  let contentBannerType = null
  if (bannerType !== null) {
    contentBannerType = bannerType?.includes('BIG') ? BANNER_TYPE.CAROUSEL : BANNER_TYPE.FIXED
  }
  const contentEventCategory = isOsmos ? EVENT_CATEGORY.ADVERTISEMENT : EVENT_CATEGORY.BANNER

  const content: BannerContentInterface = {
    [EPK.BANNER_CONTENT.SOURCE]: source,
    [EPK.BANNER_CONTENT.CAMPAIGN_NAME]: isOsmos ? campaignName : null,
    [EPK.BANNER_CONTENT.NAME]: isOsmos ? name : null,
    [EPK.BANNER_CONTENT.ID]: adId,
    [EPK.BANNER_CONTENT.LINK]: imageUrl,
    [EPK.BANNER_CONTENT.POSITION]: position ?? 0,
    [EPK.BANNER_CONTENT.BANNER_TYPE]: contentBannerType,
    [EPK.BANNER_CONTENT.TYPE]: contentType,
    [EPK.BANNER_CONTENT.DESTINATION_URL]: link,
    [EPK.BANNER_CONTENT.DURATION]: duration ?? 0,
    [EPK.BANNER_CONTENT.REDEEMED_STATUS]: redeemedStatus,
    ...(includeDwellTime && { [EPK.BANNER_CONTENT.DWELL_TIME]: dwellTime ?? null }),
  }

  return {
    ...getCommonParams(),
    SCREEN_SECTION: null,
    BUSINESS_VERTICAL: businessVertical,
    EVENT_CATEGORY: contentEventCategory,
    CONTENT: content,
  }
}

export const createBannerClickedEventParams = (
  banner: BannerInput | null | undefined,
  businessVertical: string = BUSINESS_VERTICAL.GROCERY,
): BannerClickedEventParams => {
  return createBannerEventParams(banner, businessVertical, true)
}

export const createBannerViewedEventParams = (
  banner: BannerInput | null | undefined,
  businessVertical: string = BUSINESS_VERTICAL.GROCERY,
): BannerClickedEventParams => {
  return createBannerEventParams(banner, businessVertical, false)
}
